import * as React from 'react';
import c from 'classnames';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTitle: React.FC<ThemeProps> = ({
  entity,
  ...props
}) => (
  <h2 className={c('TaxonomyThemeTitle')} {...props}>
    {entity.getIn(['name', 0, 'value'])}
  </h2>
);

export default TaxonomyThemeTitle;
